module.exports = __webpack_public_path__ + "static/media/chat_02.1ba0e87f.png";